import { render } from "./MainTwoDepth.vue?vue&type=template&id=4739ab1e&scoped=true"
import script from "./MainTwoDepth.vue?vue&type=script&lang=js"
export * from "./MainTwoDepth.vue?vue&type=script&lang=js"

import "./MainTwoDepth.vue?vue&type=style&index=0&id=4739ab1e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4739ab1e"]])

export default __exports__